/*Menu*/

.links a {
	display: grid;
	grid-template-columns: 1fr 20px;
	grid-template-rows: 1fr;
	color: var(--cf-menu-ink);
	gap: 0px 0px;
	grid-template-areas: '. .';
	padding: 10px;
	text-align: start;
	transition: color ease-out 220ms;
}

.links a:hover {
	color: var(--cf-menu-ink-hover);
}

.language {
	display: flex;
	max-width: 100%;
	overflow: hidden;
	border: 0px;
	min-height: 40px;
	justify-content: space-between;
	align-items: center;
	color: var(--cf-menu-ink);
	padding: 0px 10px;
	transition: color ease-out 220ms;
}

.language select {
	margin-inline-start: auto;
	max-width: 100%;
}

.language > :first-child {
	padding-inline-start: 0px;
}

.language > :last-child {
	padding-inline-end: 0px;
}

.font-button {
	display: grid;
	grid-auto-columns: 1fr;
	grid-template-columns: 1fr 1fr 1fr;
	/* `auto`, not `1fr`: a stretched track would leave `align-content`
	   nothing to centre. */
	grid-template-rows: auto;
	gap: 0px 0px;
	grid-template-areas: '. . .';
	/* The two buttons and the label share one baseline (`align-items`), and
	   the row keeps its 40px by centring that line vertically with
	   `align-content`, the same place the other menu rows' labels sit. */
	align-items: baseline;
	align-content: center;
	min-height: 40px;
	/* Vertical padding so a label that wraps to two lines (Spanish) keeps
	   clear of the row's border; one-line labels still sit at 40px. */
	padding: 8px 10px;
}

.font-button span {
	display: flex;
	justify-content: center;
	align-items: center;
}

.font-button button {
	/* Same size and line box as the "Text Size" label (the shared menu's
	   `.menu span`), so the icon below lines up with its baseline. The
	   32px tap height is kept with padding rather than a fixed height,
	   which would push the baseline around. */
	font-size: 0.9rem;
	padding: 6px 0;
	border: 0px;
	cursor: pointer;
	background: transparent;
}

/* Text-height, on the baseline -- see the shared menu's matching rule. */
.font-button button svg {
	display: inline-block;
	width: 1em;
	height: 1em;
	/* The box's bottom is not where the strokes end. `AArrowDown`/`AArrowUp`
	   draw the letter and arrow down to y=16 of Lucide's 24-unit viewBox,
	   and the 2-unit stroke's round cap reaches y=17, so 7 units are empty
	   below. Lowering the box by that much puts the bottom of the "A", not
	   the empty space, on the label's baseline. */
	vertical-align: calc(-7em / 24);
	/* Keeps the icon from growing its line box (a 1em box is taller than
	   the font's ascent), which would push it off the label's baseline once
	   the row centres the two boxes. Paint is unaffected. */
	margin-top: -1em;
}

.font-button button:first-of-type {
	margin-inline-end: auto;
}

.font-button button:last-of-type {
	margin-inline-start: auto;
}

.legal {
	border-top: 1px solid var(--cf-menu-border);
	font-size: 0.7rem;
	padding: 5px;
	font-family: var(--content-font-family);
}

.legal > div {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 20px;
	gap: 8px 10px;
	grid-template-areas:
		'copyright copyright'
		'. .';
}

.legal > div > :first-child {
	grid-area: copyright;
	line-height: 1.5;
}

.legal > div > div,
.legal a {
	color: var(--cf-menu-ink-muted);
	transition: color ease-out 220ms;
}

.legal a:hover {
	color: var(--cf-menu-ink-hover);
}

@keyframes showDialog {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@-webkit-keyframes showDialog {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@keyframes hideDialog {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
}

@-webkit-keyframes hideDialog {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.spin {
	animation: spin 1s linear infinite;
}

/* Favorite/Download toggle icons: both always render `fill="currentColor"`
   now (previously toggled the `fill` prop itself between that and the
   lucide default `"none"`, an instant snap CSS can't animate a value to/
   from `none`). `fill-opacity` is what's actually toggled -- 0 leaves only
   the icon's stroke visible (the "unfavorited"/"not downloaded" look),
   transitioning to 1 reads as the icon filling in rather than a hard cut. */
.fillable-icon {
	fill-opacity: 0;
	transition: fill-opacity ease-out 220ms;
}

.fillable-icon-active {
	fill-opacity: 1;
}
